import {
  FETCH_SUPPORTTYPE_INIT_ACTION,
  FETCH_SUPPORTTYPE_SUCCESS_ACTION,
  FETCH_SUPPORTTYPE_FAIL_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_SUPPORTTYPE_SUCCESS_ACTION:
      return {
        ...state,
        supportTypeList: action.payload.rows,
        supportTypeCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
